import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

//Mui
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";

// Charlist Deps

import { Grid } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import db, { storage } from "../../../firebase/firebase";
import Displayimages from "./DisplayImages/DisplayImages";
import DisplayBanners from "./DisplayBanners/DisplayBanners";
import ConfirmDialog from "../../../hooks/Dialogs/ConfirmDialog";
import Portrait from "../../../hooks/Portrait/Portrait";

import {
  selectCharacter,
  changeCharacterName,
  changeCritEmote,
  changeCritFailEmote,
  changeCharacterPortrait,
  changeCharacterBanner,
  changeCharacterMacro,
  changeMacro1,
  changeMacro2,
  changeMacro3,
  characterLogout,
} from "../../../store/reducers/characterSlice";
import { selectUser } from "../../../store/reducers/userSlice";
import classes from "./Profile.module.css";
import DisplayMacros from "./DisplayMacros/DisplayMacros";
import Loader from "../../../hooks/IsLoading/Loader/Loader";
import InlineEdit from "../../../hooks/InlineEdit/InlineEdit";
import FireflyAnimation from "../../../hooks/Animations/FireflyAnimation";


function Profile() {
  const dispatch = useDispatch();
  const history = useHistory();
  const character = useSelector(selectCharacter);
  const user = useSelector(selectUser);
  const [profileCharacter, setProfileCharacter] = useState(null);
  const [inputName, setInputName] = useState("");
  const [inputCritEmote, setInputCritEmote] = useState("");
  const [inputCritFailEmote, setInputCritFailEmote] = useState("");
  const [inputMacro1, setInputMacro1] = useState("");
  const [inputMacro2, setInputMacro2] = useState("");
  const [inputMacro3, setInputMacro3] = useState("");
  const [portraitData, setPoratraitData] = useState({ portraits: [] });
  const [bannerData, setBannerData] = useState({ banners: [] });
  const [macroData, setMacroData] = useState({ macros: [] });
  const [open, setOpen] = React.useState(false);
  const confirmOpen = open;

  const toggleModal = () => {
    setOpen(!open);
  };

  // Gets Char Portraits only when component mounts
  useEffect(() => {
    let bannerUrls = { banners: [] };
    let storageRef = storage.ref();
    let listRef = storageRef.child("/resources/images/banners/");
    listRef
      .listAll()
      .then(function (result) {
        result.items.forEach(function (item) {
          item.getDownloadURL().then((result) => {
            bannerUrls.banners.push(result);
            setBannerData(bannerUrls);
          });
        });
      })
      .catch(function (error) { });
  }, []);

  //Gets banners only when component mounts
  useEffect(() => {
    let portraitUrls = { portraits: [] };
    let storageRef = storage.ref();
    let listRef = storageRef.child("/resources/images/avatars/");
    listRef
      .listAll()
      .then(function (result) {
        result.items.forEach(function (item) {
          item.getDownloadURL().then((result) => {
            portraitUrls.portraits.push(result);
            setPoratraitData(portraitUrls);
          });
        });
      })
      .catch(function (error) { });
  }, []);

  // Gets Macro icons only when component mounts
  useEffect(() => {
    let macroUrls = { macros: [] };
    let storageRef = storage.ref();
    let listRef = storageRef.child("/resources/images/macros/");
    listRef
      .listAll()
      .then(function (result) {
        result.items.forEach(function (item) {
          item.getDownloadURL().then((result) => {
            macroUrls.macros.push(result);
            setMacroData(macroUrls);
          });
        });
      })
      .catch(function (error) { });
  }, []);

  const handleRemoveCharacter = () => {
    db.collection("users")
      .doc(user.uid)
      .collection("characters")
      .doc(character.activeCharacter)
      .delete()
      .then(function () {
        console.log("Document successfully deleted!");
        history.push("/");
        dispatch(characterLogout());
      })
      .catch(function (error) {
        console.error("Error removing document: ", error);
      });
  };

  const handleBackButtonClick = () => {
    history.push("/");
  };

  const updateCharactarValue = (updateValue) => {
    db.collection("users")
      .doc(user.uid)
      .collection("characters")
      .doc(character.activeCharacter)
      .update(updateValue);
  };

  const updateDatabaseValue = (stateFunction, dbDict) => {
    dispatch(stateFunction);
    updateCharactarValue(dbDict);
  };

  const updateCharacterPortrait = (portrait) => {
    updateDatabaseValue(changeCharacterPortrait(portrait), {
      "character.characterPortrait": portrait,
    });
  };

  const updateCharacterBanner = (banner) => {
    updateDatabaseValue(changeCharacterBanner(banner), {
      "character.characterBanner": banner,
    });
  };

  const updateCharacter1Macro = (macro) => {
    updateDatabaseValue(changeCharacterMacro(macro), {
      "character.macro1Icon": macro,
    });
  };

  const updateCharacter2Macro = (macro) => {
    updateDatabaseValue(changeCharacterMacro(macro), {
      "character.macro2Icon": macro,
    });
  };

  const updateCharacter3Macro = (macro) => {
    updateDatabaseValue(changeCharacterMacro(macro), {
      "character.macro3Icon": macro,
    });
  };

  // Upon character portrait file-input change
  const uploadCharacterPortrait = (e) => {
    let image = e.target.files[0];
    let path = `characters/` + character.activeCharacter;
    let imagePath = path + "/" + image.name;

    const uploadTask = storage.ref(imagePath).put(image);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // progress function ...
        // const progress = Math.round(
        //     (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        // );
        //this.setState({ progress });
      },
      (error) => {
        // Error function ...
        console.log(error);
      },
      () => {
        // complete function ...
        storage
          .ref(path)
          .child(image.name)
          .getDownloadURL()
          .then((url) => {
            console.log("uploaded image url " + url);
            updateCharacterPortrait(url);
          });
      }
    );
  };

  // Initialising inputs
  const setInputs = (inputChar) => {
    setProfileCharacter(inputChar);
    setInputName(inputChar.character.characterName);
    setInputCritEmote(inputChar.character.critEmote);
    setInputCritFailEmote(inputChar.character.critFailEmote);
    setInputMacro1(inputChar.character.macro1);
    setInputMacro2(inputChar.character.macro2);
    setInputMacro3(inputChar.character.macro3);
  };

  useEffect(() => {
    if (character.activeCharacter) {
      //comment
      let docRef = db
        .collection("users")
        .doc(user.uid)
        .collection("characters")
        .doc(character.activeCharacter);
      let unsubscribe = docRef.onSnapshot(function (doc) {
        // on character load
        if (doc.exists) {
          setInputs(doc.data());
          setProfileCharacter(doc.data());
        }
      });

      return () => {
        unsubscribe();
      };
    }
  }, [character.activeCharacter, user.uid]);

  let profile = <Loader />;
  if (profileCharacter) {
    profile = (
      <div className={classes.wallpaper}>
        <div
          className={classes.profile__back__button}
          onClick={handleBackButtonClick}
        >
          <IconButton>
            <CloseIcon fontSize="medium" color="primary" />
          </IconButton>
        </div>
        <Grid
          container
          spacing={3}
          direction="column"
          alignItems="center"
          justify="center"
        >
          <Grid item xl={12} xs={12}>
            <div className={classes.profile__spheres}>
              <Portrait character={profileCharacter.character} />
            </div>
          </Grid>
        </Grid>

        <div className={classes.gradient__box}>
          <form className={classes.form__group}>
            <Grid
              container
              spacing={3}
              direction="column"
              alignItems="center"
              justify="center"
            >
              <Grid item xs={12}>
                <div className={classes.CharNameInput}>
                  <InlineEdit
                    text={inputName}
                    label="Character Name"
                    onSetText={(text) => {
                      setInputName(text);
                      updateDatabaseValue(changeCharacterName(text), {
                        "character.characterName": text,
                      });
                    }}
                  />
                </div>
              </Grid>

              <Grid item xs={12}>
                <div className={classes.TextOnlyPadding}>
                  <Displayimages
                    imageList={portraitData.portraits}
                    onCLickAction={updateCharacterPortrait}
                    fileUploadDestination={uploadCharacterPortrait}
                  ></Displayimages>
                </div>
              </Grid>

              <Grid item xs={12}>
                <div className={classes.TextOnlyPadding}>
                  <DisplayBanners
                    imageList={bannerData.banners}
                    onCLickAction={updateCharacterBanner}
                  ></DisplayBanners>
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.TextOnlyPadding}>
                  <InlineEdit
                    text={inputCritEmote}
                    label="Critical Hit Emote"
                    onSetText={(text) => {
                      setInputCritEmote(text);
                      updateDatabaseValue(changeCritEmote(text), {
                        "character.critEmote": text,
                      });
                    }}
                  />
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.TextOnlyPadding}>
                  <InlineEdit
                    text={inputCritFailEmote}
                    label="Critical Fail Emote"
                    onSetText={(text) => {
                      setInputCritFailEmote(text);
                      updateDatabaseValue(changeCritFailEmote(text), {
                        "character.critFailEmote": text,
                      });
                    }}
                  />
                </div>
              </Grid>
              <Grid
                container
                spacing={3}
                direction="column"
                alignItems="center"
                justify="center"
              >
                <Grid item xs={12}>
                  <div
                    className={classes.TextFieldPadding}
                    noValidate
                    autoComplete="off"
                  >
                    <DisplayMacros
                      imageList={macroData.macros}
                      macroSourceImg={profileCharacter.character.macro1Icon}
                      onCLickAction={updateCharacter1Macro}
                    // fileUploadDestination={uploadCharacterMacro}
                    ></DisplayMacros>
                    <InlineEdit
                      text={inputMacro1}
                      label="Macro 1"
                      onSetText={(text) => {
                        setInputMacro1(text);
                        updateDatabaseValue(changeMacro1(text), {
                          "character.macro1": text,
                        });
                      }}
                    />

                  </div>
                </Grid>

                <Grid item xs={12}>
                  <div
                    className={classes.TextFieldPadding}
                    noValidate
                    autoComplete="off"
                  >
                    <DisplayMacros
                      imageList={macroData.macros}
                      macroSourceImg={profileCharacter.character.macro2Icon}
                      onCLickAction={updateCharacter2Macro}
                    // fileUploadDestination={uploadCharacterMacro}
                    ></DisplayMacros>
                    <InlineEdit
                      text={inputMacro2}
                      label="Macro 2"
                      onSetText={(text) => {
                        setInputMacro2(text);
                        updateDatabaseValue(changeMacro2(text), {
                          "character.macro2": text,
                        });
                      }}
                    />
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <div
                    className={classes.TextFieldPadding}
                    noValidate
                    autoComplete="off"
                  >
                    <DisplayMacros
                      imageList={macroData.macros}
                      macroSourceImg={profileCharacter.character.macro3Icon}
                      onCLickAction={updateCharacter3Macro}
                    // fileUploadDestination={uploadCharacterMacro}
                    ></DisplayMacros>
                    <InlineEdit
                      text={inputMacro3}
                      label="Macro 3"
                      onSetText={(text) => {
                        setInputMacro3(text);
                        updateDatabaseValue(changeMacro3(text), {
                          "character.macro3": text,
                        });
                      }}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} xl={12}>
                  <div className={classes.delete__button}>
                    <IconButton onClick={toggleModal}>
                      <ConfirmDialog
                        title="Delete Character?"
                        open={confirmOpen}
                        toggleModal={toggleModal}
                        onConfirm={handleRemoveCharacter}
                      >
                        Are you sure you want to delete this character?
                    </ConfirmDialog>
                      <DeleteIcon fontSize="medium" color="primary" />
                    </IconButton>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </form>
          <FireflyAnimation></FireflyAnimation>
        </div>
      </div>
    );
  }
  return (
    <div className={classes.profile}>

      <div className={classes.grey__background}>{profile}</div>
    </div>
  );
}

export default Profile;
